// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3pVqz","unreadBadge":"styles_unreadBadge__2RFju","modalContent":"styles_modalContent__1Kkg1","modal":"styles_modal__16ndZ"};